export const quickPrintEnglish = {};
